export { default } from './LoginPage';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/LoginPage/index.js